import {
  OPEN_IDLE_POPUP, CLOSE_IDLE_POPUP,
  SAVE_POPUP_TIMER, TOGGLE_POPUP_TIMER, DATA_FINISHED, CHECKED_TICKETS, CHECK_CASHOUT_TICKET, TICKET_SCAN,
} from './actionTypes';

/**
 * @name finishLoading
 * @description finish the loader of Tickets
 * @param {bool} payload
 * @returns {bool}
 */
export const finishLoading = (payload) => ({
  type: DATA_FINISHED,
  payload,
});
/**
 * @name checkCashoutTicket
 * @description Back End sends the ticket for cashout , if
 * it is available
 * @param {object} payload
 * @returns {object}
 */
export const checkCashoutTicket = (payload) => {
  return {
    type: CHECK_CASHOUT_TICKET,
    payload,
  };
};
/**
 * @name ticketScan
 * @description adding scanned ticket tio redux store uiState.Tickets.
 * Open ui component
 * @param {object} payload
 * @param {bool} bool
 * @returns {Object}
 */
export const ticketScan = (payload, bool, barcode) => ({
  type: TICKET_SCAN,
  payload,
  bool,
  barcode,
});
/**
 * @name checkedTickets
 * @description getting checked tickets from terminal (Igor).
 * Open ui component
 * @param {array} array
 * @returns {array}
 */
export const checkedTickets = (payload) => ({
  type: CHECKED_TICKETS,
  payload,
});
/**
 * @name toggleTimerPopup
 * @description toggle the timer for MultipleTickets in the Header
 * Open ui component
 * @param {payload} bool
 * @returns {bool}
 */
export const toggleTimerInPopup = (payload) => ({
  type: TOGGLE_POPUP_TIMER,
  payload,
});
/**
 * @name saveTimer
 * @description Saves The timer after Popup is minimized
 * @param {payload} number
 * @returns {number}
 */
export const saveTimer = (payload) => ({
  type: SAVE_POPUP_TIMER,
  payload,
});

export const OpenIdlePopup = () => ({ type: OPEN_IDLE_POPUP });
export const CloseIdlePopup = () => ({ type: CLOSE_IDLE_POPUP });
